const RENTER_GENERIC_MESSAGE = "We couldn't load this properly. Please try again.";
const AUTH_STATUS_CODES = [401, 403];

export function getActivationLoadErrorView({ apiState, variant, backTo, backLabel }) {
  const error = apiState?.error || null;
  const isError = !apiState?.inProgress && !!error;
  const statusCode = error?.statusCode;

  return {
    isError,
    shouldRedirectToLogin: isError && AUTH_STATUS_CODES.includes(statusCode),
    message:
      variant === 'admin'
        ? error?.details?.serverErrorMessage || error?.message
        : RENTER_GENERIC_MESSAGE,
    referenceId: variant === 'admin' ? error?.details?.errorReferenceKey : undefined,
    backTo,
    backLabel,
  };
}
